import React from 'react';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import ReinstatementsList from './ReinstatementsList';

interface Props {
	cancellationData: CancellationData;
}

const Reinstatements = (props: Props) => {
	const { cancellationData } = props;

	const { selectedCancellation } = cancellationData;

	const { reinstatement } = selectedCancellation;

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Reinstatements</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<ReinstatementsList
					reinstatements={reinstatement ? [reinstatement] : []}
				/>
			</StyledSectionContainer>
		</>
	);
};

export default withCancellationContext<Props>(Reinstatements);
